import { ReactNode } from 'react';

import { OpSpace } from 'new-components/DLS/OpSpace/OpSpace';
import { OpCard } from 'new-components/DLS/OpCard/OpCard';

interface QuickActionCardProps {
  title: string;
  icon: ReactNode;
  color: string;
  onClick?: () => void;
}

const QuickActionCard = ({
  title,
  icon,
  color,
  onClick,
}: QuickActionCardProps) => {
  return (
    <OpCard
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        backgroundColor: color,
        cursor: 'pointer',
        transition: 'background-color 0.3s',
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        const target = e.currentTarget;
        target.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        const target = e.currentTarget;
        target.style.transform = 'scale(1)';
      }}
    >
      <OpSpace
        orientation="vertical"
        align="center"
        style={{ textAlign: 'center' }}
      >
        <div style={{ textAlign: 'center' }}>{icon}</div>
        <div
          style={{
            marginTop: '10px',
            fontSize: '16px',
            color: 'var(--colorTextSecondary)',
            textTransform: 'uppercase',
            letterSpacing: '1px',
          }}
        >
          {title}
        </div>
      </OpSpace>
    </OpCard>
  );
};

export default QuickActionCard;
